export default "__VITE_ASSET__672fe9ab__"